export function generateModalHTML(data) {
  return `
    <div class="modal-inner" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <h2 class="modal-ds-title" id="modal-title">${data.title}</h2>
      <div class="line-mob"></div>
      <div class="modal-imgList-wrapper">
        <img
          class="modal-ds-img"
          src="${data.image}"
          alt="${data.imageAlt || 'Image related to service'}"
          width="350"
          height="250"
        />
        <ul class="modal-ds-list">
          ${data.list
            .map(
              item =>
                `<li class="modal-ds-item"><p class="modal-ds-text">${item}</p></li>`
            )
            .join('')}
        </ul>
      </div>
      <div class="line"></div>
      <h3 class="modal-ds-subtitle">${data.subtitle}</h3>
      <p class="modal-ds-text-secondary">${data.text}</p>
      <a href="#contacts">
        <button class="button modal-close button-modal-order" aria-label="${
          data.ariaOrderBtn || 'Go to transfer order form'
        }">
          ${data.ariaLabel.orderButtonText || 'Order Transfer'}
        </button>
      </a>
      <button class="button-modal-close modal-close" aria-label="${
        data.ariaCloseBtn || 'Close modal window'
      }">
        <svg class="mpdal-close-svg" width="24" height="24" aria-hidden="true">
          <use href="/img/svg/sprite.svg#close"></use>
        </svg>
      </button>
    </div>
  `;
}
